var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHkexpressMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_25708",
    "data-name": "Group 25708",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.29,
    height: 19.791,
    viewBox: "0 0 24.29 19.791",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g20536",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path20538",
    d: "M129.185,395.575c0,.211-.115.288-.269.288h-1.442c-.615,0-.768-.154-.768-.846v-3.536c0-.922-.153-1.076-.884-1.076h-4.4c-.769,0-.9.134-.9,1.057v3.575c0,.672-.192.826-.807.826H118.25c-.192,0-.25-.135-.25-.346V383.179a.272.272,0,0,1,.25-.307h1.441c.634,0,.826.135.826.865v3.42c0,.981.173,1.038.9,1.038h4.42c.692,0,.865-.154.865-.98v-10.3c0-.672.154-.845.768-.845h1.442c.231,0,.269.154.269.346Z",
    transform: "translate(-118 -376.072)",
    fill: "#6e2d91"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g20540",
    transform: "translate(13.065 2.436)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path20542",
    d: "M179.263,396.02c0,.673.038.73.615.73H181.4a1.7,1.7,0,0,0,1.9-1.1l1.5-2.922a1.984,1.984,0,0,1,2.037-1.345h.865c.135,0,.385.077.212.423l-2.5,4.882a2.991,2.991,0,0,0-.423,1.172,3.628,3.628,0,0,0,.462,1.384l2.44,4.747c.115.25-.077.385-.269.385h-.9a2,2,0,0,1-2.114-1.4l-1.461-2.9a1.653,1.653,0,0,0-1.806-1.172h-1.5c-.519,0-.577.1-.577.769v4.035c0,.481-.192.673-.692.673h-1.595c-.193,0-.231-.1-.231-.346V387.313c0-.193.077-.288.25-.288h1.652c.442,0,.615.23.615.653Z",
    transform: "translate(-176.745 -387.025)",
    fill: "#6e2d91"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHkexpressMini);
export default __webpack_public_path__ + "static/media/hkexpress-mini.b47c422cf2b0b8faba89b641610dfca0.svg";
export { ForwardRef as ReactComponent };